import { StyledCell } from '../../../../../../ResourceAllocationOverview/JiraStats/useTableRows/Row.style';
import { Tooltip } from '@material-ui/core';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { StyledLink } from 'components/base/common-styles';
import { Flex } from 'components/base/layout-components';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { pmToolDefinitionSelector } from 'state/selectors/sensors-authorizations';
import ProgressionTableContext from '../../../context/ProgressionTableContext';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const ViewInProviderTooltip = ({ providerName }) => {
  return (
    <Flex padding='x-small'>
      <Text mr='0.8rem'>View in {providerName}</Text>
      <Icon name='LinkArrow' size='x-small' />
    </Flex>
  );
};

const LinkToProviderCell = ({ title, url }) => {
  const { tableType } = useContext(ProgressionTableContext);
  const pmToolDefinition = useSelector(pmToolDefinitionSelector);
  const providerName = pmToolDefinition?.name || 'Provider';

  const onClickAmplitudeTracking = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.PROJECT_PROGRESSION,
      click_type:
        TRACKING.CLICK.PROJECT_PROGRESSION.PROGRESSION_TABLE
          .LINK_TO_PROVIDER_CELL,
      element: tableType.name,
      provider: providerName
    });
  };

  return (
    <StyledCell>
      {url ? (
        <Tooltip
          title={<ViewInProviderTooltip providerName={providerName} />}
          placement='top-start'
        >
          <StyledLink
            target='_blank'
            href={url}
            onClick={onClickAmplitudeTracking}
          >
            {title}
          </StyledLink>
        </Tooltip>
      ) : (
        <span>{title}</span>
      )}
    </StyledCell>
  );
};

export default LinkToProviderCell;
